import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";

export const Section14 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    return (
        <animated.div className={styles['animation-container']} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <div className={`${styles.sec} ${styles.sec14} ${styles['dark-gray']}`}>
                <animated.span className={`${styles.sec14__font01} ${styles.notoBold} ${styles.ab} ${(frame > 0 && frame < 1) && styles['z-index-10']}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.2, 0.8, 1],
                        output: [0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.2, 0.8, 1],
                        output: [10, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>빗썸 고객</animated.span>
                <animated.p className={`${styles.sec14__font02} ${styles.marginDel} ${styles.ab} ${(frame > 0 && frame < 1) && styles['z-index-10']}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.2, 0.8, 1],
                        output: [0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.2, 0.8, 1],
                        output: [10, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>이라면</animated.p>
                <animated.span className={`${styles.sec14__font03} ${styles.notoBold} ${styles.ab} ${(frame > 0 && frame < 1) && styles['z-index-10']}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.4, 0.5, 0.8, 1],
                        output: [0, 0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.4, 0.5, 0.8, 1],
                        output: [10, 10, 0, 0, -20]
                    }).to(x => `${x}vh`)
                }}>든든</animated.span>
                <animated.p className={`${styles.sec14__font04} ${styles.marginDel} ${styles.ab} ${(frame > 0 && frame < 1) && styles['z-index-10']}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.4, 0.5, 0.8, 1],
                        output: [0, 0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.4, 0.5, 0.8, 1],
                        output: [10, 10, 0, 0, -20]
                    }).to(x => `${x}vh`)
                }}>하게!</animated.p>
            </div>
        </animated.div>
    )
}